import React from 'react';
import { useSelector } from 'react-redux';
import { getAccountDetailsContent } from '../../store/contentSlice';
import InlineRetrieveAccountError from '../errors/InlineLowesAccountError';

const PendedAccountCard = ({ clientId = '' }: any) => {
  const { unableToProvideAccountNumberText, accountPendedMessage }: any =
    useSelector(getAccountDetailsContent);

  return clientId === 'lowes' ? (
    <InlineRetrieveAccountError />
  ) : (
    <div className="account-pending-message-wrapper">
      <div className="account-pending-state-message">
        {unableToProvideAccountNumberText}
      </div>
      <div className="account-message">{accountPendedMessage}</div>
    </div>
  );
};

export default PendedAccountCard;
